import { typeWireOf } from "@typewirets/core";
import { FormulaParserWire } from "./formula-parser.wire";
import { FormulaValidationService } from "./formula-validation-service";

/**
 * TypeWire definition for FormulaValidationService.
 *
 * This service provides formula validation and metadata for formula building.
 * It's a singleton service that can be injected into components that need
 * formula validation capabilities.
 *
 * @example
 * ```tsx
 * import { useTypeWire } from "@typewirets/react";
 * import { FormulaValidationServiceWire } from "@/lib/formula-validation-service.wire";
 *
 * function MyComponent() {
 *   const validationService = useTypeWire(FormulaValidationServiceWire);
 *
 *   const handleValidate = (formula: string) => {
 *     const result = validationService.validateFormula(formula);
 *     console.log(result.isValid ? "Valid!" : result.error);
 *   };
 *
 *   return <div>...</div>;
 * }
 * ```
 */
export const FormulaValidationServiceWire = typeWireOf({
  token: "FormulaValidationService",
  imports: {
    formulaParser: FormulaParserWire,
  },
  createWith({ formulaParser }) {
    return new FormulaValidationService(formulaParser);
  },
});
